import * as types from '../../action-types';
import { mentorship as initialState } from '../initialStates';

const mentorship = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case types.MENTORSHIP_START:
            return {
                ...state,
                isLoading: true,
            }
        case types.MENTORSHIP_SUCCESS:
            return {
                ...state,
                isSuccessful: true,
                data: payload,
            }
        case types.MENTORSHIP_FAIL:
            return {
                ...state,
                error: payload
            }
        case types.MENTORSHIP_CLEANUP:
            return {
                ...state,
                error: null,
                isSuccessful: false
            }
        default:
            return state;
    };
};

export default mentorship;

